import React from "react";
import Modal from "../Modal";

export default function TeamInviteModal({
  isOpen,
  onClose,
  inviteUrl,
  copied,
  setCopied
}) {
  return (
    isOpen && (
      <Modal isOpen={isOpen} onClose={onClose}>
        <div className="text-center">
          <h2 className="text-lg font-semibold mb-4">Invite Team Members</h2>
          <p className="mb-4 text-sm text-gray-600 dark:text-gray-300">Share this link to invite new members to your team:</p>
          <div className="flex items-center justify-center gap-2 mb-6">
            <input
              type="text"
              value={inviteUrl}
              readOnly
              className="w-full px-3 py-2 rounded bg-gray-100 dark:bg-gray-800 text-gray-800 dark:text-gray-100 border border-gray-200 dark:border-gray-700 font-mono text-xs"
            />
            <button
              className="px-2 py-1 rounded bg-blue-600 text-white hover:bg-blue-700 transition text-xs"
              onClick={() => {
                navigator.clipboard.writeText(inviteUrl);
                setCopied(true);
                setTimeout(() => setCopied(false), 1500);
              }}
            >
              {copied ? "Copied!" : "Copy"}
            </button>
          </div>
          <button
            className="px-4 py-2 rounded bg-gray-200 dark:bg-gray-700 text-gray-800 dark:text-gray-200 hover:bg-gray-300 dark:hover:bg-gray-600 transition"
            onClick={onClose}
          >
            Close
          </button>
        </div>
      </Modal>
    )
  );
}
